// extracted by mini-css-extract-plugin
module.exports = {"docsetTocContainer":"Docset_docsetTocContainer__2ueHL","textVersion":"Docset_textVersion__18SUu"};